import { Link } from "react-router-dom";

/** The counter in one place: the customers' scans, their carts, and the QR that brings them in. */
export function CustomerTabs({
  active,
  openCarts,
  onShowQr,
  qrDisabled,
}: {
  active: "scans" | "carts";
  openCarts: number;
  onShowQr: () => void;
  qrDisabled?: boolean;
}) {
  const tab = (on: boolean) =>
    `flex flex-1 items-center justify-center gap-1.5 rounded-btn px-3 py-2 text-sm font-medium transition-colors sm:flex-none ${
      on ? "bg-accent text-ink" : "text-muted hover:bg-surface-strong hover:text-white"
    }`;
  return (
    <div className="mb-6 flex flex-wrap items-center justify-between gap-3">
      <h1 className="text-lg font-bold text-white">Customer</h1>
      <nav className="flex w-full gap-1 rounded-btn bg-surface p-1 sm:w-auto" aria-label="Customer">
        <Link
          to="/customer-scans"
          className={tab(active === "scans")}
          aria-current={active === "scans" ? "page" : undefined}
        >
          Scans
        </Link>
        <Link
          to="/customer-carts"
          className={tab(active === "carts")}
          aria-current={active === "carts" ? "page" : undefined}
        >
          Carts
          {openCarts > 0 && (
            <span
              className={`inline-flex h-[18px] min-w-[18px] items-center justify-center rounded-full px-1 text-[10px] font-semibold ${
                active === "carts" ? "bg-ink text-accent" : "bg-accent text-ink"
              }`}
            >
              {openCarts > 99 ? "99+" : openCarts}
              <span className="sr-only"> open</span>
            </span>
          )}
        </Link>
        <button type="button" onClick={onShowQr} disabled={qrDisabled} className={tab(false)}>
          Shop QR
        </button>
      </nav>
    </div>
  );
}
